





























import Vue, { PropType } from 'vue';
import { perPageList } from '@/configs/tableConfigs';
import { DropdownList } from '@/types';
import TableService from '@/services/TableService';

export default Vue.extend({
  name: 'TableToolPerPage',

  props: {
    perPage: {
      type: Number,
      required: true,
    },
    perPageList: {
      type: Array as PropType<Array<DropdownList>>,
      required: false,
      default: perPageList,
    },
  },

  destroyed() {
    TableService.changePerPage();
  },

  watch: {
    perPage: {
      handler(newValue: number) {
        TableService.changePerPage(newValue);
      },
      immediate: true,
    },
  },

  methods: {
    closeModal() {
      this.modal = false;
    },
    checkPerPage(value: number) {
      return Number(this.perPage) === value;
    },
    select(item: DropdownList) {
      this.closeModal();
      this.change(item);
    },
    change(item: DropdownList) {
      this.$emit('change', item.value);
    },
  },

  data() {
    return {
      modal: false,
    };
  },
});
